var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 select-customer-properties-container"},[_c('select',{ref:"select",staticClass:"form-control form-control-lg customer-properties-tom-selector",attrs:{"placeholder":'Select ' +_vm.propertyComputed.property_name.toLowerCase(),"multiple":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }